import { connect } from 'react-redux'

import { getProductByProfileId, setSortProductByProfile } from 'reduxpath/ducks/Profile/Detail'

import SortCreatedServiceCard from './units'

const mapStateToProps = state => ({
  productsProfile: state.ProfileDetail.productsProfile,
  profileId: state.ProfileDetail.data.profileId,
})

const mapDispatchToProps = dispatch => ({
  toggleSortProductByProfile(sort, profileId) {
    return () => {
      const dataSort = {
        ...sort,
        active: 'createdAt',
      }

      dataSort.createdAt = dataSort.createdAt === 'ASC' ? 'DESC' : 'ASC'

      const limit = 25
      const page = 0
      const qs = {
        limit,
        skip: page * limit,
      }

      if (dataSort.active) {
        qs.sort = {
          createdAt: dataSort.createdAt,
        }
      }

      dispatch(setSortProductByProfile(dataSort))
      dispatch(getProductByProfileId(profileId, qs))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(SortCreatedServiceCard)
